import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../services/i18nService';
import stringUtils from '../../../../../../qti/utils/StringUtils';
import styles from './WordCountText.scss';

const WordCounter = ({ text, maxWords }) => {
    const words = stringUtils.countWords(text);
    const maxWordsCountText = t('essay.wordsCount', { words, maxWords });

    return maxWords > 0 ?
        <span className={styles.wordCountText}>{maxWordsCountText}</span> :
        <span className={styles.wordCountText}>{t('essay.wordCount', { words })}</span>;
};

WordCounter.propTypes = {
    text: PropTypes.string.isRequired,
    maxWords: PropTypes.number.isRequired,
};

export default WordCounter;
